export default class GoogleAnalyticsEventCategory {
  static get TdvMetrics() {
    return this.getInstance('TDV Metrics');
  }

  static get TdvEvents() {
    return this.getInstance('TDV Events');
  }

  static get RealtimeEvents() {
    return this.getInstance('Realtime Events');
  }

  static fromKey(key) {
    const statusMap = {
      'TDV Metrics': GoogleAnalyticsEventCategory.TdvMetrics,
      'TDV Events': GoogleAnalyticsEventCategory.TdvEvents,
      'Realtime Events': GoogleAnalyticsEventCategory.RealtimeEvents,
    };
    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new GoogleAnalyticsEventCategory(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(GoogleAnalyticsEventCategory, 'instances', { value: {} });
